export const guideVideoData = [
  {
    key: "cosyLiveTrading",
    eyebrow: "Before You Explore",
    title: "COSY Live Trading — Watch This First",
    subtitle:
      "In the next 90 seconds, you will see how the market truly moves as a connected system — and why serious investors don’t trade in fragments.",
    bullets: [
      "How capital flows across crypto, stocks, options, and yields — as one system",
      "Why most investors feel lost — and react too late",
      "How COSY helps you connect the dots and act with clarity",
    ],
    bodyText:
      "Most people study markets in isolation. Professionals understand how everything moves together.\n\nIf you want to stop guessing and start seeing the full market picture, this short briefing will change how you approach investing.",
    videoUrl: "https://www.youtube.com/watch?v=PJ4v3yiZ1GE",
  },

  {
    key: "tradeThroughNight",
    eyebrow: "Before You Explore",
    title: "Trade Through The Night — Watch This First",
    subtitle:
      "In the next 90 seconds, you will see how institutional capital is revealed in real time — and how serious investors position before the market moves.",
    bullets: [
      "How Wall Street’s largest money managers reveal their positions",
      "Why most investors react after the move — and miss the opportunity",
      "How SpikingAI® turns real-time disclosures into actionable trades",
    ],
    bodyText:
      "Once every quarter, the market exposes something rare — fresh institutional footprints.\n\nMost people see data. We see intent, conviction, and positioning.\n\nIf you want to stop reacting to headlines and start trading with real-time intelligence, this short briefing will change how you approach the market.",
    videoUrl: "https://www.youtube.com/watch?v=DsyZKMWbp6g",
  },

  {
    key: "marsCoaching",
    eyebrow: "Before You Explore",
    title: "MARS Coaching — Watch This First",
    subtitle:
      "In the next 90 seconds, you will see how serious investors move beyond information — into structured execution, discipline, and real transformation.",
    bullets: [
      "Why most investors stay stuck — even with the right tools",
      "How elite investors build clarity, discipline, and repeatable systems",
      "How MARS Coaching helps you turn knowledge into consistent performance",
    ],
    bodyText:
      "Most investors collect insights. Very few build structure, discipline, and conviction.\n\nMARS Coaching is not another program. It is where your thinking is refined, your process is sharpened, and your execution is pressure-tested.",
    videoUrl: "https://www.youtube.com/watch?v=aZs0FdYARmo",
  },

  {
    key: "premiumCourses",
    eyebrow: "Before You Explore",
    title: "Premium Courses — Watch This First",
    subtitle:
      "In the next 90 seconds, you will see how serious investors build a structured foundation — so every decision is backed by clarity, not guesswork.",
    bullets: [
      "Why most investors stay inconsistent — without a clear framework",
      "How professional investors think in systems, not isolated trades",
      "How Premium Courses help you build repeatable, data-driven strategies",
    ],
    bodyText:
      "Most investors jump from idea to idea. Serious investors follow a structured approach.",
    videoUrl: "https://www.youtube.com/watch?v=BR5IfJ1ntm8",
  },

  {
    key: "upgradeToPremium",
    eyebrow: "Before You Explore",
    title: "Upgrade to Premium",
    subtitle: "",
    bullets: [],
    bodyText: "",
    videoUrl: "https://www.youtube.com/watch?v=2VOXVMipKGE",
  },

  {
    key: "newsletter",
    eyebrow: "Before You Explore",
    title: "Spiking Newsletter — Watch This First",
    subtitle:
      "In the next 90 seconds, see how to stay informed without the noise.",
    bullets: [
      "Why most people consume information but gain no edge",
      "How to focus only on what truly matters",
      "How the newsletter turns updates into insight",
    ],
    bodyText:
      "Most people follow headlines. Serious investors focus on signals.\n\nOne clear read each week.",
    videoUrl: "https://www.youtube.com/watch?v=ioXQfJ0S4KA",
  },

  {
    key: "calendar",
    eyebrow: "Before You Explore",
    title: "Calendar — Watch This First",
    subtitle: "In the next 90 seconds, see why timing is the real edge.",
    bullets: [
      "Why most investors react too late",
      "How key events move markets",
      "How to prepare before it happens",
    ],
    bodyText: "Before the market moves, the calendar moves first.",
    videoUrl: "https://www.youtube.com/watch?v=gWMr0O_x_vk",
  },

  {
    key: "spikingUpDown",
    eyebrow: "Before You Explore",
    title: "Spiking Up & Down — Watch This First",
    subtitle:
      "In the next 90 seconds, see how traders identify tomorrow’s spikes before they happen.",
    bullets: [
      "Why most investors chase too late",
      "How spikes leave signals before price moves",
      "How Spiking helps you act with precision",
    ],
    bodyText: "We focus on what’s about to move — not what already moved.",
    videoUrl: "https://www.youtube.com/watch?v=GfXhJS5WPqw",
  },

  {
    key: "dailyBread",
    eyebrow: "Before You Explore",
    title: "Daily Bread — Watch This First",
    subtitle:
      "In the next 90 seconds, you will see how to trade earnings with clarity and discipline.",
    bullets: [
      "Why earnings create opportunity",
      "Why most investors react too late",
      "How Daily Bread helps you act with structure",
    ],
    bodyText: "Enter before earnings. Exit after the reaction.",
    videoUrl: "https://www.youtube.com/watch?v=P9EWXcxL6TA",
  },

  {
    key: "resurrection",
    eyebrow: "Before You Explore",
    title: "Resurrection — Watch This First",
    subtitle:
      "In the next 90 seconds, you will see how to position around high-impact biotech catalysts.",
    bullets: [
      "Why FDA events create powerful opportunities",
      "Why most investors react too late",
      "How Resurrection helps you act with structure",
    ],
    bodyText: "Position before the event. Act before the crowd.",
    videoUrl: "https://www.youtube.com/watch?v=irWcWX7sACM",
  },

  {
    key: "triangulation",
    eyebrow: "Before You Explore",
    title: "Triangulation — Watch This First",
    subtitle:
      "In the next 90 seconds, you will see how to position with quarterly clarity — not daily noise.",
    bullets: [
      "Why most investors get lost in short-term volatility",
      "How real trends reveal themselves over time",
      "How Triangulation helps you act with confirmation",
    ],
    bodyText: "Three months. Three signals. One direction.",
    videoUrl: "https://www.youtube.com/watch?v=KrrqqTsP6IQ",
  },

  {
    key: "trillion",
    eyebrow: "Before You Explore",
    title: "Trillion — Watch This First",
    subtitle:
      "In the next 90 seconds, you will see how to identify long-term market leaders.",
    bullets: [
      "Why most investors chase short-term moves",
      "How real wealth is built through compounding",
      "How Trillion helps you focus on future giants",
    ],
    bodyText: "Own what the market cannot ignore.",
    videoUrl: "https://www.youtube.com/watch?v=RjNGPoR5zuw",
  },

  {
    key: "fiat",
    eyebrow: "Before You Explore",
    title: "FIAT Analysis — Watch This First",
    subtitle:
      "In the next 90 seconds, you will see how serious investors validate — not guess.",
    bullets: [
      "Why one angle is never enough",
      "How smart money leaves clues",
      "How FIAT turns signals into conviction",
    ],
    bodyText: "Not opinion. Validation.",
    videoUrl: "https://www.youtube.com/watch?v=x9dS60oAa5o",
  },

  {
    key: "spikingAI",
    eyebrow: "Before You Explore",
    title: "SpikingAI® + Prompt — Watch This First",
    subtitle:
      "In the next 90 seconds, you will see how AI turns information into decision.",
    bullets: [
      "Why most investors think slower than the market",
      "How AI helps you see and interpret faster",
      "How Prompt sharpens your judgment and conviction",
    ],
    bodyText: "Together, they help you decide.",
    videoUrl: "https://www.youtube.com/watch?v=6y5WEBiTmBs",
  },

  {
    key: "holyGrailPortfolio",
    eyebrow: "Before You Explore",
    title: "Holy Grail Portfolio — Watch This First",
    subtitle:
      "In the next 90 seconds, you will see how serious investors build structure — not random exposure.",
    bullets: [
      "Why most investors lose without a portfolio system",
      "How structure reduces risk before returns",
      "How Holy Grail turns ideas into disciplined allocation",
    ],
    bodyText: "Remove risk first. Then pursue returns.",
    videoUrl: "https://www.youtube.com/watch?v=F6qXaHx91fY",
  },

  {
    key: "insiderInvestors",
    eyebrow: "Before You Explore",
    title: "Insider Investors — Watch This First",
    subtitle:
      "In the next 90 seconds, you will see how to read what serious money is actually doing.",
    bullets: [
      "Why opinions can mislead — but capital leaves clues",
      "How top investors reveal conviction through transactions",
      "How Insider Investors helps you follow real money flow",
    ],
    bodyText: "Watch what they do.",
    videoUrl: "https://www.youtube.com/watch?v=eBUZFK4cN18",
  },

  {
    key: "activeTraders",
    eyebrow: "Before You Explore",
    title: "Active Traders — Watch This First",
    subtitle:
      "In the next 90 seconds, you will see how to find your true investing style.",
    bullets: [
      "Why most investors struggle with the wrong style",
      "How different capital moves across the spectrum",
      "How Active Traders helps you align with the right approach",
    ],
    bodyText: "Find what fits you.",
    videoUrl: "https://www.youtube.com/watch?v=o5-wAQViFBk",
  },

  {
    key: "top10BuySell",
    eyebrow: "Before You Explore",
    title: "Top 10 Buy/Sell — Watch This First",
    subtitle:
      "In the next 90 seconds, you will see where real money is moving today.",
    bullets: [
      "Why headlines don’t reflect true market moves",
      "How capital reveals real conviction",
      "How Top 10 Buy/Sell sharpens your focus",
    ],
    bodyText: "Follow the dollars. Ignore the noise.",
    videoUrl: "https://www.youtube.com/watch?v=-Y2_zyv7Ezg",
  },

  {
    key: "top30AIStocks",
    eyebrow: "Before You Explore",
    title: "Top 30 AI Stocks — Watch This First",
    subtitle:
      "In the next 90 seconds, you will see how to invest in AI as a system — not one stock.",
    bullets: [
      "Why most investors misunderstand AI",
      "How the AI ecosystem actually works",
      "How Top 30 helps you see the full picture",
    ],
    bodyText: "A connected ecosystem.",
    videoUrl: "https://www.youtube.com/watch?v=UYGhc_MyBh4",
  },

  {
    key: "top200SMA",
    eyebrow: "Before You Explore",
    title: "Top 200 SMA — Watch This First",
    subtitle:
      "In the next 90 seconds, you will see how to buy quality with discipline — not chase price.",
    bullets: [
      "Why most investors chase strength",
      "How great stocks return to value",
      "How Top 200 SMA helps you time entries",
    ],
    bodyText: "Discipline beats emotion.",
    videoUrl: "https://www.youtube.com/watch?v=mHFFqUrAMfs",
  },

  {
    key: "ytdPerformance",
    eyebrow: "Before You Explore",
    title: "YTD Performance — Watch This First",
    subtitle:
      "In the next 90 seconds, see how the market truly rewards performance — and why serious investors focus on results, not opinions.",
    bullets: [
      "What YTD performance reveals about market leaders",
      "Why most investors react too late",
      "How to track where capital is flowing",
    ],
    bodyText:
      "YTD performance is the scoreboard — showing where strength is already proven.\nThis is not about chasing.\nIt's about recognising strength early and acting with clarity.",
    videoUrl: "https://www.youtube.com/watch?v=doFzzpSKe4c",
  },
];
